import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { FindingAiService, InLineControlAiService } from '../api/agentStep.model';
import { getAiServiceDisplayName, getAiServiceLogoPath } from 'src/app/common/aiServiceUtils';
import { RSA_DEMO_FINDING_AI_SERVICES } from './rsaDemoAiServices';

const rsaDemoSet = new Set<string>(RSA_DEMO_FINDING_AI_SERVICES);

export const aidrAiServiceSelectOptions: ISelectOption[] = Object.values(FindingAiService)
  .filter((service) => !rsaDemoSet.has(service))
  .map((service) => ({
    id: `${FilterTypesEnum.AiService}-${service}`,
    value: service,
    displayName: getAiServiceDisplayName(service),
    withoutBeautifyDisplayName: true,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(service),
  }))
  .sort((a, b) => a.displayName.localeCompare(b.displayName));

export const aidrAiServiceSelectOptionsWithRsaDemo: ISelectOption[] = Object.values(FindingAiService)
  .map((service) => ({
    id: `${FilterTypesEnum.AiService}-${service}`,
    value: service,
    displayName: getAiServiceDisplayName(service),
    withoutBeautifyDisplayName: true,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(service),
  }))
  .sort((a, b) => a.displayName.localeCompare(b.displayName));

/**
 * Inline mode AI service select options
 * Uses InLineControlAiService enum values with unified FilterTypesEnum.AiService
 * Excludes 'unknown' service from the filter options
 */
export const inlineUnifiedAiServiceSelectOptions: ISelectOption[] = Object.values(InLineControlAiService)
  .filter((service) => service !== InLineControlAiService.unknown)
  .map((service) => ({
    id: `${FilterTypesEnum.AiService}-${service}`,
    value: service,
    displayName: getAiServiceDisplayName(service),
    withoutBeautifyDisplayName: true,
    filterType: FilterTypesEnum.AiService,
    categoryName: FilterTypesEnum.AiService.toString(),
    iconPath: getAiServiceLogoPath(service),
  }))
  .sort((a, b) => a.displayName.localeCompare(b.displayName));
